module.exports = __webpack_public_path__ + "static/img/toronto2.9b0bb3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/toronto2.jpg
// module id = 142
// module chunks = 9